import React from "react";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PageShell = ({ kicker, title, subtitle, children, testid }) => (
  <div className="min-h-screen bg-background text-foreground" data-testid={testid}>
    <Navbar />
    <main className="pt-16">
      <section className="max-w-4xl mx-auto px-6 pt-16 pb-10 border-b border-white/5">
        {kicker && <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-3">{kicker}</p>}
        <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
          className="font-heading text-4xl sm:text-5xl font-black tracking-tight">{title}</motion.h1>
        {subtitle && <p className="mt-4 text-muted-foreground text-lg max-w-2xl">{subtitle}</p>}
      </section>
      <section className="max-w-4xl mx-auto px-6 py-14">{children}</section>
    </main>
    <Footer />
  </div>
);

export default PageShell;
